import { useMutation } from 'react-query'
import request from '../request'
import { OnboardingFormValues } from '../../pages/Onboarding/Onboarding'

export const usePostFinishOnboarding = () => {
  return useMutation((data: OnboardingFormValues) =>
    request({
      url: '/onboarding',
      method: 'POST',
      data: data,
      // @ts-expect-error TS(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
    }).then((res) => res.data),
  )
}
